/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelAppointmentRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'
import {CancelAppointmentResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'


export const cancelAppointment = (request: CancelAppointmentRequest, options?: CashRequestOptions) => post<CancelAppointmentRequest, CancelAppointmentResponse>("/2.0/cash/cancel-appointment", request, {...options, rejectOnError: true })